import React from 'react';
import { ChatPopup } from '@gtintel/platform-chat';
import { RouteRolesEnum } from '@gtintel/platform-types';
export function displayChatPopup({
  identity,
  channel_sid,
  typeChat,
  popupName,
  groupMembers,
  isAssignmentPartnerChat
}) {
  const dataChat = {
    identity,
    channel_sid,
    groupMembers,
    typeChat,
    popupName,
    hideChat: false
  };
  const {
    listChatConnecting
  } = this.state;
  const {
    adminProjectDetailStore
  } = this.props;
  const {
    projectDetail
  } = adminProjectDetailStore;
  const hasCreate = listChatConnecting.some(item => {
    // eslint-disable-next-line eqeqeq
    return item?.identity && dataChat?.identity && item.identity == dataChat.identity;
  });
  if (hasCreate) {
    return;
  }
  listChatConnecting.push(dataChat);
  const chatPopup = <div className="ChatPopupContainer" ref={el => {
    this.scrollToChat = el;
  }}>
      {listChatConnecting.map((chatConnecting, i) => {
      return <ChatPopup key={i} type_chat={chatConnecting.typeChat} projectInfo={projectDetail} project_name={projectDetail.name} project_id={projectDetail.id} receiver_id={chatConnecting.identity} channel_sid={chatConnecting.channel_sid} popupName={chatConnecting.popupName} groupMembers={chatConnecting.groupMembers} request_anonymity={projectDetail.request_anonymity} onRef={ref => {
        this[`child${chatConnecting.channel_sid}`] = ref;
      }} getLoca={loca => {
        this.scrollHorizontal(loca);
      }} routeRole={RouteRolesEnum.ADMIN} suggestedPartners={this.state.getPartner?.result ?? []} hideHeader={false} hideChat={chatConnecting.hideChat} isAssignmentPartnerChat={isAssignmentPartnerChat} />;
    })}
      <div style={{
      float: 'left',
      clear: 'both'
    }} ref={el => {
      this.listpopupchat = el;
    }} />
    </div>;
  this.setState({
    chatPopup,
    listChatConnecting
  }, () => {
    this.scrollToRight();
  });
}